import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from "react";
import {} from "@stackje/common/fontSet";
import { FontSetContext } from "./FontSetContext";
export const FontSetProvider = ({ initialFontSetId = "modern", children, }) => {
    const [fontSetId, setFontSetId] = useState(initialFontSetId);
    return (_jsx(FontSetContext.Provider, { value: { fontSetId, setFontSetId }, children: children }));
};
